import { modalOverlayStore } from '@atomic-ui/modalOverlay';
import { wishlistStore } from '@common-vue/add-to-wishlist';
import { slideoutStore } from '@atomic-ui/slideout';
import recommendationStore from '../src/store_modules/store';

export default {
  namespaced: true,
  state() {
    return {};
  },
  getters: {},
  mutations: {},
  modules: {
    recommendationStore,
    wishlistStore,
    modalOverlayStore,
    slideoutStore,
  },
  actions: {},
};
